import {
    Fade,
    IconButton,
    Menu,
    MenuItem,
    StandardProps,
    Theme,
    Typography
} from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/styles";
import { StyleClassKey } from "js/react/typescript";

import { MoreVert as MoreVertIcon } from "@material-ui/icons";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import NearMeIcon from "@material-ui/icons/NearMe";
import clsx from "clsx";
import { RenderWithConfirmation } from "js/react/components";
import {
    MediaContentRendererProps,
    PermissionTypeEnum,
    UIMediaContent
} from "js/react/scenes/components/MediaManagement/Types";
import React, { useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PermissionContext } from "..";

const styles = (theme: Theme) =>
    createStyles({
        options: {
            marginLeft: "10px"
        },
        icons: {
            fontSize: "15px"
        },
        pointerIcon: {
            fontSize: "15px",
            marginLeft: "3px"
        }
    });

type MoreActionMenuClassKey = StyleClassKey<typeof styles>;
const useStyles = makeStyles(styles);

interface MoreActionMenuProps
    extends StandardProps<{}, never>,
        Pick<
            MediaContentRendererProps,
            "onChosen" | "onDelete" | "onRename" | "selectionType"
        > {
    media: UIMediaContent;
    showPreviewIcon: boolean;
    setPreviewToggle?: (preview: boolean) => void;
}

export const MoreActionMenu = (props: MoreActionMenuProps) => {
    const classes = useStyles(props);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const { media } = props;
    const permission = useContext(PermissionContext);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton
                className={clsx(props.className)}
                aria-controls="fade-menu"
                aria-haspopup="true"
                onClick={handleClick}
            >
                <MoreVertIcon />
            </IconButton>
            <RenderWithConfirmation
                onConfirm={() => {
                    props.onDelete(media);
                    handleClose();
                }}
                dialogMessage={`Please confirm that you want to delete ${media.DisplayName}.`}
                permanent={true}
                dialogTitle={"Delete item?"}
            >
                {renderProps => (
                    <Menu
                        id="fade-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={open}
                        onClose={handleClose}
                        TransitionComponent={Fade}
                    >
                        {(!permission ||
                            permission === PermissionTypeEnum.WRITE) && (
                            <MenuItem
                                onClick={() => {
                                    renderProps.askConfirmation();
                                    handleClose();
                                }}
                            >
                                <FontAwesomeIcon
                                    icon={["fas", "trash"]}
                                    className={classes.icons}
                                />
                                <Typography className={classes.options}>
                                    Delete
                                </Typography>
                            </MenuItem>
                        )}
                        {/*<MenuItem
                            onClick={() => {
                                handleClose();
                                props.onRename(media);
                            }}
                        >
                            <EditIcon className={classes.icons}/>
                            Rename
                        </MenuItem>*/}
                        {props.selectionType === media.type && (
                            <MenuItem
                                onClick={() => {
                                    props.onChosen(media);
                                    handleClose();
                                }}
                            >
                                <FontAwesomeIcon
                                    icon={["fas", "mouse-pointer"]}
                                    className={classes.pointerIcon}
                                />
                                <Typography className={classes.options}>
                                    Select
                                </Typography>
                            </MenuItem>
                        )}
                        {props.showPreviewIcon && media.type === "file" && (
                            <MenuItem
                                onClick={() => {
                                    props.setPreviewToggle(true);
                                }}
                            >
                                <FontAwesomeIcon
                                    icon={["fas", "external-link"]}
                                    className={classes.icons}
                                />
                                <Typography className={classes.options}>
                                    Preview
                                </Typography>
                            </MenuItem>
                        )}
                    </Menu>
                )}
            </RenderWithConfirmation>
        </>
    );
};
